import { render, staticRenderFns } from "./CategoriasIngresos.vue?vue&type=template&id=45dbbec5&scoped=true"
import script from "./CategoriasIngresos.vue?vue&type=script&lang=js"
export * from "./CategoriasIngresos.vue?vue&type=script&lang=js"
import style0 from "./CategoriasIngresos.vue?vue&type=style&index=0&id=45dbbec5&prod&lang=scss"
import style1 from "./CategoriasIngresos.vue?vue&type=style&index=1&id=45dbbec5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dbbec5",
  null
  
)

export default component.exports